import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { changePassword } from '../auth/api';
import '../pages/Admin.css';

export default function ChangePasswordModal({ onClose }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    setLoading(true);
    try {
      await changePassword(currentPassword, newPassword);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="admin-modal-overlay">
      <div className="admin-modal">
        <button className="admin-modal-close" onClick={() => onClose()} aria-label="Cerrar">✕</button>
        <h3 className="admin-modal-title">Cambiar contraseña</h3>

        {success ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <p style={{ color: '#27ae60', fontWeight: 600, marginBottom: 16 }}>✓ Contraseña actualizada correctamente</p>
            <button type="button" className="admin-btn admin-btn-primary" onClick={() => onClose()}>Cerrar</button>
          </div>
        ) : (
          <>
            {error && <p className="admin-error" role="alert" style={{ marginBottom: 12 }}>{error}</p>}

            <form className="admin-form" onSubmit={handleSubmit}>
              <div className="admin-field">
                <label htmlFor="cp-current">Contraseña actual</label>
                <input id="cp-current" type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required autoComplete="current-password" />
              </div>

              <div className="admin-field">
                <label htmlFor="cp-new">Nueva contraseña</label>
                <input id="cp-new" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required autoComplete="new-password" />
                <small style={{ color: '#888', fontSize: '0.75rem' }}>Mín. 8 caracteres, con letras y números</small>
              </div>

              <div className="admin-field">
                <label htmlFor="cp-confirm">Confirmar nueva contraseña</label>
                <input id="cp-confirm" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required autoComplete="new-password" />
              </div>

              <div className="admin-form-actions">
                <button type="button" className="admin-btn admin-btn-outline" onClick={() => onClose()}>Cancelar</button>
                <button type="submit" className="admin-btn admin-btn-primary" disabled={loading}>
                  {loading ? 'Guardando...' : 'Cambiar contraseña'}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  , document.body);
}

